import { createRouter, createWebHistory } from 'vue-router'
import AppLayout from '@/layout/AppLayout.vue'
import AuthService from '@/services/AuthService'
import { useUserStore } from '@/stores/user'
import { ROLES } from '@/config'

/** Rotte raggiungibili senza sessione. */
const PUBLIC_PATHS = ['/auth/login', '/auth/access', '/auth/error', '/notfound']

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      // Il pannello e' solo per l'admin di piattaforma: il ruolo vale per tutte le pagine figlie
      path: '/',
      component: AppLayout,
      meta: { roles: [ROLES.ADMIN] },
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () => import('@/views/pages/dashboard/Dashboard.vue'),
        },
        {
          path: 'subscriptions',
          name: 'subscriptions',
          component: () => import('@/views/pages/subscriptions/Subscriptions.vue'),
        },
        {
          path: 'users',
          name: 'users',
          component: () => import('@/views/pages/users/Users.vue'),
        },
        {
          path: 'sites',
          name: 'sites',
          component: () => import('@/views/pages/sites/Sites.vue'),
        },
        {
          path: 'plans',
          name: 'plans',
          component: () => import('@/views/pages/plans/Plans.vue'),
        },
      ],
    },
    {
      // Consenso OAuth dei client MCP: serve un utente registrato, di qualunque ruolo
      path: '/oauth/authorize',
      name: 'oauthAuthorize',
      component: () => import('@/views/pages/oauth/Authorize.vue'),
    },
    { path: '/auth/login', name: 'login', component: () => import('@/views/pages/auth/Login.vue') },
    { path: '/auth/access', name: 'accessDenied', component: () => import('@/views/pages/auth/Access.vue') },
    { path: '/auth/error', name: 'error', component: () => import('@/views/pages/auth/Error.vue') },
    { path: '/notfound', name: 'notfound', component: () => import('@/views/pages/auth/NotFound.vue') },
    { path: '/:catchAll(.*)*', redirect: '/notfound' },
  ],
})

/**
 * Guard unica dell'app:
 * 1. le rotte pubbliche passano sempre
 * 2. senza sessione -> /auth/login
 * 3. profilo caricato una volta sola e messo nello store
 * 4. `meta.roles` (ereditato dalle rotte padre) filtra per ruolo -> /auth/access
 */
router.beforeEach(async (to) => {
  if (PUBLIC_PATHS.includes(to.path)) return true

  const userStore = useUserStore()
  const session = await AuthService.waitForAuth()

  if (!session) {
    userStore.clearUser()
    return { path: '/auth/login', query: { redirect: to.fullPath } }
  }

  if (!userStore.user) {
    try {
      userStore.setUser(await AuthService.fetchProfile())
    } catch {
      userStore.clearUser()
      return '/auth/login'
    }
  }

  if (!userStore.hasRole(to.meta.roles)) {
    return '/auth/access'
  }

  return true
})

export default router
